exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".damage-parts_part + .damage-parts_part {\n  margin-top: 3.2rem;\n}\n.damage-parts_part .damage-parts_part_piece + .damage-parts_part_piece {\n  margin-top: 2.4rem;\n}", ""]);

// exports
